import { useContext } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { UsuarioContext } from "../../providers/personaContext";
import { HiAcademicCap } from "react-icons/hi2";
import { IoSchoolSharp, IoBook, IoDocumentOutline, IoSettingsSharp, IoAdd } from "react-icons/io5";
import { LiaSchoolSolid } from "react-icons/lia";
import { GiOrganigram } from "react-icons/gi";
import { FaBuilding, FaUsersLine, FaNewspaper, FaClock, FaUmbrellaBeach, FaCalendarCheck, FaClipboardList, FaCalendarPlus, FaUserPlus, FaUserMinus, FaEnvelopesBulk } from "react-icons/fa6";
import { RUTA_BUZONES, CLAVE_GESTIONAR as CLAVE_CORREOS } from "../../componentes/correos/api";
import { RiOrganizationChart } from "react-icons/ri";
import { GrDocumentConfig } from "react-icons/gr";
import { MdBusinessCenter, MdAccessTime, MdEventAvailable, MdDashboard, MdPhoneInTalk, MdSecurity } from "react-icons/md";
import { FaLayerGroup } from "react-icons/fa";
import { BsGraphUp, BsCalendar2Event, BsPersonSquare } from "react-icons/bs";
import CustomTooltip from "../eventos/avisos/Tooltip";
import useIntervencionesDisponibilidad from "../../componentes/intervenciones/hooks/useIntervencionesDisponibilidad";
import { GoGraph } from "react-icons/go";


const convocatoriaMenuItems = {
  Administrador: [
    { path: "/convocatoria/cursos", icon: IoSchoolSharp, text: "Cursos" },
    { path: "/convocatoria/categorias", icon: IoBook, text: "Categorías" },
    { path: "/convocatoria/subcategorias/", icon: LiaSchoolSolid, text: "Subcategorías" },
  ],
  "Super Administrador": [
    { path: "/convocatoria/cursos", icon: IoSchoolSharp, text: "Cursos" },
    { path: "/convocatoria/categorias", icon: IoBook, text: "Categorías" },
    { path: "/convocatoria/subcategorias/", icon: LiaSchoolSolid, text: "Subcategorías" },
  ],
  "Gestor de Contenidos": [
    { path: "/convocatoria/cursos", icon: IoSchoolSharp, text: "Cursos" },
    { path: "/convocatoria/categorias", icon: IoBook, text: "Categorías" },
    { path: "/convocatoria/subcategorias/", icon: LiaSchoolSolid, text: "Subcategorías" },
  ],
  "Recursos Humanos": [],
  General: [],
  default: [
    { path: "/convocatoria/cursos", icon: IoSchoolSharp, text: "Cursos" },
  ]
};

const bonificadaMenuItems = {
  Administrador: [
    { path: "/bonificados/cursos", icon: HiAcademicCap, text: "Cursos" },
    { path: "/bonificados/categorias", icon: IoBook, text: "Categorías" },
  ],
  "Super Administrador": [
    { path: "/bonificados/cursos", icon: HiAcademicCap, text: "Cursos" },
    { path: "/bonificados/categorias", icon: IoBook, text: "Categorías" },
  ],
  "Gestor de Contenidos": [
    { path: "/bonificados/cursos", icon: HiAcademicCap, text: "Cursos" },
    { path: "/bonificados/categorias", icon: IoBook, text: "Categorías" },
  ],
  General: [],
  default: [
    { path: "/bonificados/cursos", icon: HiAcademicCap, text: "Cursos" },
  ]
};

/* ── EL ORGANIGRAMA NO ESTA ABANDONADO: ESTA OCULTO Y EN USO ────────────────────────────────
 *
 * Su entrada de menu esta comentada abajo en los SEIS bloques de este objeto, desde julio de 2025
 * y por decision de direccion. Pero **la ruta `/gestionpersonas/organigrama` sigue viva en
 * `App.js`, y hay gente que entra por URL directa y la usa** para consultar el organigrama. De
 * cara a 2027 puede volver a hacerse visible.
 *
 * Esto se escribe aqui porque el riesgo es de LECTURA: «oculto por decision de direccion» se lee
 * como *abandonado*, y alguien podria retirar la ruta creyendo que limpia un resto.
 *
 *     La ruta sobrevive a su entrada de menu solo mientras nadie la confunda con un descuido.
 *
 * Si se recupera, se descomentan las seis lineas. **Si se quiere retirar, se pregunta antes**:
 * hoy tiene usuarios que no aparecen en ningun menu, asi que su uso no se puede medir mirando la
 * navegacion.
 *
 * (Y su criterio de a quien pinta cambio en Fase D: filtra por situacion «Alta», no por `activo`
 *  — el porque, en `peticiones_API/PeticionesOrganigrama.js`. Con `activo` estaba pintando cuatro
 *  personas de baja en local y TEST, asi que ese cambio le importa a quien la usa HOY.)
 */
const personasMenuItems = {
  Administrador: [
    { path: "/gestionpersonas/personas", icon: FaUsersLine, text: "Personas" },
    { path: "/gestionpersonas/empresas", icon: FaBuilding, text: "Empresas" },
    { path: "/gestionpersonas/departamentos", icon: FaLayerGroup, text: "Departamentos" },
    { path: "/gestionpersonas/oficinas", icon: MdBusinessCenter, text: "Oficinas" },
    // ORGANIGRAMA — oculto a proposito y EN USO por URL, no abandonado. Ver la cabecera de este objeto.
    // { path: "/gestionpersonas/organigrama", icon: RiOrganizationChart, text: "Organigrama" }
  ],
  "Super Administrador": [
    { path: "/gestionpersonas/personas", icon: FaUsersLine, text: "Personas" },
    { path: "/gestionpersonas/empresas", icon: FaBuilding, text: "Empresas" },
    { path: "/gestionpersonas/departamentos", icon: FaLayerGroup, text: "Departamentos" },
    { path: "/gestionpersonas/oficinas", icon: MdBusinessCenter, text: "Oficinas" },
    // ORGANIGRAMA — oculto a proposito y EN USO por URL, no abandonado. Ver la cabecera de este objeto.
    // { path: "/gestionpersonas/organigrama", icon: RiOrganizationChart, text: "Organigrama" }
  ],
  "Gestor de Contenidos": [
    { path: "/gestionpersonas/personas", icon: FaUsersLine, text: "Personas" },
    { path: "/gestionpersonas/oficinas", icon: MdBusinessCenter, text: "Oficinas" },
    // ORGANIGRAMA — oculto a proposito y EN USO por URL, no abandonado. Ver la cabecera de este objeto.
    // { path: "/gestionpersonas/organigrama", icon: RiOrganizationChart, text: "Organigrama" }
  ],
  "Recursos Humanos": [
    { path: "/gestionpersonas/personas", icon: FaUsersLine, text: "Personas" },
    { path: "/gestionpersonas/oficinas", icon: MdBusinessCenter, text: "Oficinas" },
    // ORGANIGRAMA — oculto a proposito y EN USO por URL, no abandonado. Ver la cabecera de este objeto.
    // { path: "/gestionpersonas/organigrama", icon: RiOrganizationChart, text: "Organigrama" }
  ],
  General: [
    { path: "/gestionpersonas/personas", icon: FaUsersLine, text: "Personas" },
    { path: "/gestionpersonas/oficinas", icon: MdBusinessCenter, text: "Oficinas" },
    // ORGANIGRAMA — oculto a proposito y EN USO por URL, no abandonado. Ver la cabecera de este objeto.
    // { path: "/gestionpersonas/organigrama", icon: RiOrganizationChart, text: "Organigrama" }
  ],
  default: [
    { path: "/gestionpersonas/personas", icon: FaUsersLine, text: "Personas" },
    { path: "/gestionpersonas/oficinas", icon: MdBusinessCenter, text: "Oficinas" },
    // ORGANIGRAMA — oculto a proposito y EN USO por URL, no abandonado. Ver la cabecera de este objeto.
    // { path: "/gestionpersonas/organigrama", icon: RiOrganizationChart, text: "Organigrama" }
  ]
};

const wikiMenuItems = {
  Administrador: [
    { path: "/documentos/wiki", icon: IoDocumentOutline, text: "Wiki" },
    { path: "/documentos/gestionar", icon: GrDocumentConfig, text: "Documentos" }
  ],
  "Super Administrador": [
    { path: "/documentos/wiki", icon: IoDocumentOutline, text: "Wiki" },
    { path: "/documentos/gestionar", icon: GrDocumentConfig, text: "Documentos" }
  ],
  "Gestor de Contenidos": [
    { path: "/documentos/wiki", icon: IoDocumentOutline, text: "Wiki" }
  ],
  "Recursos Humanos": [
    { path: "/documentos/wiki", icon: IoDocumentOutline, text: "Wiki" }
  ],
  General: [
    { path: "/documentos/wiki", icon: IoDocumentOutline, text: "Wiki" }
  ],
  default: [
    { path: "/documentos/wiki", icon: IoDocumentOutline, text: "Wiki" }
  ]
};

const inventarioMenuItems = {
  Administrador: [
    { path: "/utilidades", icon: FaClock, text: "Reservas" }
  ],
  "Super Administrador": [
    { path: "/utilidades", icon: FaClock, text: "Reservas" }
  ],
  "Gestor de Contenidos": [
    { path: "/utilidades", icon: FaClock, text: "Reservas" }
  ],
  "Recursos Humanos": [
    { path: "/utilidades", icon: FaClock, text: "Reservas" }
  ],
  General: [
    { path: "/utilidades", icon: FaClock, text: "Reservas" }
  ],
  default: [
    { path: "/utilidades", icon: FaClock, text: "Reservas" }
  ]
};

const vacacionesMenuItems = {
  Administrador: [
    { path: "/panel/vacaciones/mis-solicitudes", icon: FaClipboardList, text: "Mis Solicitudes" },
    { path: "/panel/vacaciones/calendario", icon: BsCalendar2Event, text: "Calendarios" }
  ],
  "Super Administrador": [
    { path: "/panel/vacaciones/mis-solicitudes", icon: FaClipboardList, text: "Mis Solicitudes" },
    { path: "/panel/vacaciones/aprobaciones", icon: FaCalendarCheck, text: "Aprobaciones" },
    { path: "/panel/vacaciones/calendario", icon: BsCalendar2Event, text: "Calendarios" },
    { path: "/panel/vacaciones/asignacion", icon: FaCalendarPlus, text: "Asignaciones" }
  ],
  "Recursos Humanos": [
    { path: "/panel/vacaciones/mis-solicitudes", icon: FaClipboardList, text: "Mis Solicitudes" },
    { path: "/panel/vacaciones/aprobaciones", icon: FaCalendarCheck, text: "Aprobaciones" },
    { path: "/panel/vacaciones/calendario", icon: BsCalendar2Event, text: "Calendarios" },
    { path: "/panel/vacaciones/asignacion", icon: FaCalendarPlus, text: "Asignaciones" }
  ],
  "Gestor de Contenidos": [
    { path: "/panel/vacaciones/mis-solicitudes", icon: FaClipboardList, text: "Mis Solicitudes" },
    { path: "/panel/vacaciones/calendario", icon: BsCalendar2Event, text: "Calendarios" }
  ],
  General: [
    { path: "/panel/vacaciones/mis-solicitudes", icon: FaClipboardList, text: "Mis Solicitudes" },
    { path: "/panel/vacaciones/calendario", icon: BsCalendar2Event, text: "Calendarios" }
  ],
  default: [
    { path: "/panel/vacaciones/mis-solicitudes", icon: FaClipboardList, text: "Mis Solicitudes" },
    { path: "/panel/vacaciones/calendario", icon: BsCalendar2Event, text: "Calendarios" },
    { path: "/panel/vacaciones/festivos", icon: MdEventAvailable, text: "Festivos" }
  ]
};

// Sub-sidebar de Citas Técnicas: se construye por PERMISO (eje administración)
// y por PARTICIPACIÓN (eje participación), NO por rol. Es el espejo en el menú
// de `accesoMisCitas` del backend (participación O permiso). Ver
// MenuGestorIntervenciones más abajo. Estilo de cabecera de sección tomado de
// SoporteSidebar para separar visualmente los dos bloques.
function headerStyleInterv() {
  return {
    padding: '14px 12px 4px', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase',
    letterSpacing: '0.06em', color: '#64748b', listStyle: 'none', pointerEvents: 'none', userSelect: 'none',
  };
}
const BlogsMenuItems ={
   Administrador: [
    { path: "/comunicacion/blogs", icon: FaNewspaper, text: "Blogs" },
    { path: "/comunicacion/categorias", icon: LiaSchoolSolid, text: "Categorías" }
  ],
  "Super Administrador": [
    { path: "/comunicacion/blogs", icon: FaNewspaper, text: "Blogs" },
    { path: "/comunicacion/categorias", icon: LiaSchoolSolid, text: "Categorías" }
  ],
  "Recursos Humanos": [
    { path: "/comunicacion/blogs", icon: FaNewspaper, text: "Blogs" },
    { path: "/comunicacion/categorias", icon: LiaSchoolSolid, text: "Categorías" }
  ],
  "Gestor de Contenidos": [
    { path: "/comunicacion/blogs", icon: FaNewspaper, text: "Blogs" },
    { path: "/comunicacion/categorias", icon: LiaSchoolSolid, text: "Categorías" }
  ],
  Administracion: [
    { path: "/comunicacion/blogs", icon: FaNewspaper, text: "Blogs" },
    { path: "/comunicacion/categorias", icon: LiaSchoolSolid, text: "Categorías" }
  ],
  default: [
    { path: "/comunicacion/blogs", icon: FaNewspaper, text: "Blogs" },
    { path: "/comunicacion/categorias", icon: LiaSchoolSolid, text: "Categorías" }
  ]
}

export function MenuConvocatoria(props) {
  const { rol, showSidebar, convocatoria } = props;
  const menuItems = convocatoriaMenuItems[rol] || convocatoriaMenuItems.default || [];

  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <NavLink
              activeclassname="active"
              to={item.path}
              className={convocatoria ? "convocatoria" : ""}
            >
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </NavLink>
          </li>
        ))
      ) : null}
    </>
  );
}

export function MenuBonificada(props) {
  const { rol, showSidebar } = props;
  const menuItems = bonificadaMenuItems[rol] || bonificadaMenuItems.default || [];

  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <NavLink
              activeclassname="active"
              to={item.path}
            >
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </NavLink>
          </li>
        ))
      ) : null}
    </>
  );
}

export function MenuPersonas(props) {
  const { rol, showSidebar } = props;
  // Incorporaciones/Bajas se muestran por PERMISO (no por rol), con el patrón can(clave) de
  // SoporteSidebar. El resto de entradas de personas siguen siendo por rol (personasMenuItems).
  const ctx = useContext(UsuarioContext) || {};
  const isSuperAdmin = (ctx.persona?.rol || '').toLowerCase() === 'super administrador';
  const permisos = Array.isArray(ctx.permisos) ? ctx.permisos : [];
  const can = (clave) => isSuperAdmin || permisos.includes(clave);
  const permisosCargados = isSuperAdmin || ctx.permisosCargados;
  // El interruptor del módulo. NO lleva bypass de Super Administrador, y es la diferencia con
  // `can`: los permisos dicen «tú no», el interruptor dice «esto no está». Super Administrador se
  // salta lo primero por diseño, y por eso ocultar por permisos no ocultaba nada — quedaban las
  // cuentas de ese rol. El interruptor tapa a todos.
  const moduloActivo = (nombre) => (ctx.modulos || {})[nombre] === true;

  const menuItems = [...(personasMenuItems[rol] || personasMenuItems.default || [])];
  // "Incorporaciones" se inyecta por PERMISO (no por rol), JUSTO DEBAJO de "Personas" y solo
  // cuando los permisos ya cargaron (evita flash). "Bajas" NO va en el menú: es una pestaña
  // dentro de Incorporaciones (se llega por la barra de tabs, ruta /gestionpersonas/personas/bajas).
  const idxPersonas = menuItems.findIndex((it) => it.path === '/gestionpersonas/personas');
  let insertAt = idxPersonas >= 0 ? idxPersonas + 1 : menuItems.length;

  // ── BAJAS, CON ENTRADA PROPIA Y PERMANENTE ──────────────────────────────────────────────
  //
  // No la tenía: era una pestaña DENTRO de la pantalla de Incorporaciones. Eso ya estaba mal
  // —tiene su permiso `bajas.ver` y su ruta guardada por él—, y con el módulo oculto pasaba de
  // mal a inalcanzable: sin entrada, a la lista de procesos no se llega en frío, y el enlace del
  // banner de la ficha sólo existe si esa persona tiene una baja ABIERTA. Una baja cerrada, o la
  // de otro, no se alcanzaba por ningún sitio.
  //
  // Va SIN interruptor: dar de baja se abre desde la ficha y su proceso se consulta aquí. Es un
  // arreglo del menú que estaba pendiente, no una consecuencia de tapar el módulo.
  if (permisosCargados && can('bajas.ver')) {
    menuItems.splice(insertAt, 0, {
      path: '/gestionpersonas/personas/bajas',
      icon: FaUserMinus,
      text: 'Bajas',
    });
    insertAt += 1;
  }

  // ── INCORPORACIONES: PERMISO **Y** INTERRUPTOR ──────────────────────────────────────────
  if (permisosCargados && moduloActivo('incorporaciones') && can('incorporaciones.ver')) {
    menuItems.splice(insertAt, 0, {
      path: '/gestionpersonas/personas/incorporaciones',
      icon: FaUserPlus,
      text: 'Incorporaciones',
      // Subrutas del módulo que TAMBIÉN activan esta entrada (Bajas es una pestaña dentro de
      // Incorporaciones, sin entrada propia de menú). Áreas y Recursos (Fase 4) cuelgan de
      // /incorporaciones/… así que el prefijo ya las cubriría; se listan explícitas para dejar la
      // intención escrita. En fases posteriores se añaden aquí puestos/perfiles/avisos/documentos.
      // `/bajas` YA NO está aquí: tiene entrada propia, y anunciarlo como subruta de
      // Incorporaciones resaltaría la entrada equivocada.
      matchPaths: [
        '/gestionpersonas/personas/incorporaciones/areas',
        // `/cuentas` ya no está: las cuentas compartidas pasaron a «Buzones y listas» (30/10).
        '/gestionpersonas/personas/incorporaciones/recursos',
        '/gestionpersonas/personas/incorporaciones/puestos',
        '/gestionpersonas/personas/incorporaciones/perfiles',
        '/gestionpersonas/personas/incorporaciones/avisos',
        /* Las dos del 01/10. Esta lista es OTRA LISTA ESCRITA A MANO al lado de la que manda
         * —`RUTAS` de `IncorporacionesTabs`— y por eso se quedo corta: anadir una pestaña eran
         * TRES cambios (la ruta, la pestaña y esto) y se hicieron dos. El sintoma es pequeño —la
         * entrada del menu no se resalta— pero es la misma forma que costo nueve parametros en
         * `gestionURL`. */
        '/gestionpersonas/personas/incorporaciones/motivos-baja',
        '/gestionpersonas/personas/incorporaciones/tareas-baja',
      ],
    });
    insertAt += 1;
  }

  // ── BUZONES Y LISTAS (30/10): SÓLO PERMISO, SIN INTERRUPTOR ────────────────────────────
  // Las cuentas compartidas son de Personas: apagar Incorporaciones no las apaga. La misma clave
  // que la ruta de App.js y que el servidor.
  if (permisosCargados && can(CLAVE_CORREOS)) {
    menuItems.splice(insertAt, 0, {
      path: RUTA_BUZONES,
      icon: FaEnvelopesBulk,
      text: 'Buzones y listas',
    });
    insertAt += 1;
  }

  // Resaltado por COINCIDENCIA MÁS LARGA (la ruta más específica gana), considerando el `path` del
  // ítem Y sus `matchPaths` (subrutas del módulo que también lo activan, p. ej. /bajas → activa
  // "Incorporaciones"). Genérico: cualquier ítem puede declarar matchPaths. Sin esto, /bajas caía en
  // "Personas" por prefijo, al no haber entrada propia para /bajas. Conserva el resaltado por prefijo
  // de las subrutas propias (editar/crear persona siguen marcando "Personas").
  const { pathname } = useLocation();
  const matchLen = (it) =>
    [it.path, ...(it.matchPaths || [])]
      .filter((p) => p && (pathname === p || pathname.startsWith(p + '/')))
      .reduce((max, p) => Math.max(max, p.length), -1);
  let activeIndex = -1;
  let bestLen = -1;
  menuItems.forEach((it, i) => {
    const len = matchLen(it);
    if (len > bestLen) { bestLen = len; activeIndex = i; }
  });

  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <Link
              to={item.path}
              className={index === activeIndex ? 'active' : ''}
              aria-current={index === activeIndex ? 'page' : undefined}
            >
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </Link>
          </li>
        ))
      ) : null}
    </>
  );
}

export function MenuWiki(props) {
  const { rol, showSidebar } = props;
  const menuItems = wikiMenuItems[rol] || wikiMenuItems.default || [];
  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <NavLink
              activeclassname="active"
              to={item.path}
            >
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </NavLink>
          </li>
        ))
      ) : null}
    </>
  );
}

export function MenuInventario(props) {
  const { rol, showSidebar } = props;
  const menuItems = inventarioMenuItems[rol] || inventarioMenuItems.default || [];
  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <NavLink
              activeclassname="active"
              to={item.path}
            >
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </NavLink>
          </li>
        ))
      ) : null}
    </>
  );
}

export function MenuVacaciones(props) {
  const { rol, showSidebar, esColaborador } = props;
  const { ambito, ambitoCargado, ambitoError } = useContext(UsuarioContext) || {};
  let menuItems = [...(vacacionesMenuItems[rol] || vacacionesMenuItems.default || [])];

  if (esColaborador) {
    menuItems = menuItems.filter(item => item.path !== "/panel/vacaciones/festivos");
  }

  // "Aprobaciones" según el ámbito resuelto en SERVIDOR (receta de 3 estados; NUNCA por
  // ambito==null): en carga (!ambitoCargado) se oculta para no dar un flash falso; en error o
  // en LISTO con `puedeGestionar` se muestra. MISMA condición que el Outlet de ProtectedRoute
  // —en error se muestra la entrada: navegar NO autoriza (el gate del backend rechaza), pero da
  // al aprobador legítimo el camino al aviso+reintento que vive dentro de la página.
  const mostrarAprobaciones = ambitoCargado && (ambitoError || !!ambito?.puedeGestionar);
  const tieneAprobaciones = menuItems.some(item => item.path === "/panel/vacaciones/aprobaciones");
  if (mostrarAprobaciones && !tieneAprobaciones) {
    menuItems.splice(1, 0, { path: "/panel/vacaciones/aprobaciones", icon: FaCalendarCheck, text: "Aprobaciones" });
  }

  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <NavLink
              activeclassname="active"
              to={item.path}
            >
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </NavLink>
          </li>
        ))
      ) : null}
    </>
  );
}

export function MenuGestorIntervenciones(props) {
  const { showSidebar } = props;
  // Se decide por PERMISO y PARTICIPACIÓN, no por rol (espejo de accesoMisCitas).
  const ctx = useContext(UsuarioContext) || {};
  const esSuper = (ctx.persona?.rol || '').toLowerCase() === 'super administrador';
  const permisos = Array.isArray(ctx.permisos) ? ctx.permisos : [];
  const can = (clave) => esSuper || permisos.includes(clave);
  // Eje participación: reutiliza GET /mi-disponibilidad (no crea nada nuevo).
  // Durante loading el hook devuelve ambos true (anti-parpadeo).
  const { esUsuarioActivo, esTecnicoActivo } = useIntervencionesDisponibilidad();

  // Eje ADMINISTRACIÓN — por permiso fino. Super Admin ve todo.
  const itemsAdmin = [
    can('intervenciones.dashboard.view') && { path: '/citas-tecnicas/dashboard', icon: MdDashboard, text: 'Dashboard' },
    can('intervenciones.campanas.view') && { path: '/citas-tecnicas/campanas', icon: FaClipboardList, text: 'Campañas' },
    can('intervenciones.campanas.view') && { path: '/citas-tecnicas/calendario', icon: BsCalendar2Event, text: 'Calendario' },
    can('intervenciones.informes.view') && { path: '/citas-tecnicas/informes', icon: GoGraph, text: 'Informes' },
  ].filter(Boolean);

  // Eje PARTICIPACIÓN — participación viva O permiso miscitas.view (mismo OR
  // que accesoMisCitas). "Panel técnico" solo por ser técnico activo.
  const itemsPersonales = [
    (esUsuarioActivo || permisos.includes('intervenciones.miscitas.view')) && { path: '/citas-tecnicas/mis-campanas', icon: MdDashboard, text: 'Mis Citas' },
    esTecnicoActivo && { path: '/citas-tecnicas/panel-tecnico', icon: FaClipboardList, text: 'Panel técnico' },
  ].filter(Boolean);

  // Sin acceso real en ninguno de los dos ejes → no se muestra el módulo
  // (tampoco "Preferencias"): una puerta que no lleva a nada.
  if (itemsAdmin.length === 0 && itemsPersonales.length === 0) return null;

  const renderItem = (item, key) => (
    <li key={key}>
      <NavLink activeclassname="active" to={item.path}>
        <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
          {showSidebar ? (
            <>
              <item.icon />
              <span className="menuText">{item.text}</span>
            </>
          ) : (
            <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
              <div>
                <item.icon />
              </div>
            </CustomTooltip>
          )}
        </div>
      </NavLink>
    </li>
  );

  return (
    <>
      {itemsAdmin.length > 0 && (
        <>
          {showSidebar && <li style={headerStyleInterv()}>Administración</li>}
          {itemsAdmin.map((it, i) => renderItem(it, `adm-${i}`))}
        </>
      )}
      {itemsPersonales.length > 0 && (
        <>
          {showSidebar && <li style={headerStyleInterv()}>Mis citas</li>}
          {itemsPersonales.map((it, i) => renderItem(it, `per-${i}`))}
        </>
      )}
      {/* Preferencias de notificaciones: cualquier autenticado, pero solo si el
          módulo ya es visible por alguno de los dos ejes. */}
      {renderItem({ path: '/citas-tecnicas/preferencias-notificaciones', icon: IoSettingsSharp, text: 'Pref. Notificaciones' }, 'pref')}
    </>
  );
}

// MenuEstadisticas: construye dinámicamente los items según los permisos
// del usuario, no según su rol. Cada sub-item corresponde a una clave
// de permiso del sistema (ringover, etc.). Cuando añadáis más estadísticas
// (ej: "Estadísticas de ventas"), basta con añadir aquí una entrada con
// su clave de permiso correspondiente y crear el permiso en la BBDD.

const estadisticasPermissionItems = [
  { permiso: 'ringover', path: "/estadisticas/ringover", icon: MdPhoneInTalk, text: "RingOver" },
  // Futuros: { permiso: 'ventas', path: "/estadisticas/ventas", icon: ..., text: "Ventas" },
];

export function MenuEstadisticas(props) {
  const { showSidebar, tienePermiso } = props;
  const menuItems = estadisticasPermissionItems.filter(
    item => tienePermiso && tienePermiso(item.permiso)
  );
  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <NavLink activeclassname="active" to={item.path}>
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </NavLink>
          </li>
        ))
      ) : null}
    </>
  );
}


export function MenuComunicacion(props) {
  const { rol, showSidebar, esSupervisor } = props;
  let menuItems = [...(BlogsMenuItems[rol] || BlogsMenuItems.default || [])];

  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <NavLink
              activeclassname="active"
              to={item.path}
            >
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </NavLink>
          </li>
        ))
      ) : null}
    </>
  );
}

const configuracionMenuItems = {
  "Super Administrador": [
    { path: "/configuracion/permisos", icon: MdSecurity, text: "Permisos" },
    { path: "/configuracion/plantillas-notificaciones", icon: GrDocumentConfig, text: "Plantillas notif." }
  ],
  default: []
};

export function MenuConfiguracion(props) {
  const { rol, showSidebar } = props;
  const menuItems = configuracionMenuItems[rol] || configuracionMenuItems.default || [];
  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <li key={index}>
            <NavLink activeclassname="active" to={item.path}>
              <div className={`menuBtn ${showSidebar ? "expanded" : "collapsed"}`}>
                {showSidebar ? (
                  <>
                    <item.icon />
                    <span className="menuText">{item.text}</span>
                  </>
                ) : (
                  <CustomTooltip mensaje={item.text} alineado="left" tamano="1.0rem">
                    <div>
                      <item.icon />
                    </div>
                  </CustomTooltip>
                )}
              </div>
            </NavLink>
          </li>
        ))
      ) : null}
    </>
  );
}
